// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2HAkQ","Success":"Button_Success__2gT4U","Danger":"Button_Danger__3T38e"};